import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Col, Form, FormGroup, FormControl, ControlLabel, Button, Checkbox } from 'react-bootstrap'
import { getDayOptions, getMonthOptions, getYearOptions } from '../../../../Member/Modules/services/dateServices'
import Api from '../../../../Global/Modules/Api'
const FETCH_URL = "api/courses/"
class BijeenkomstAdd extends Component {
    constructor(props) {
        super(props)
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this)
        this.handleOptionsChange = this.handleOptionsChange.bind(this)
        this.state = {
            id: 0,
            Type: "B",
            refNumber: "",
            level: "",
            institution: "",
            name: "",
            city: "",
            day: "",
            month: "",
            year: "",
            phoneNumber: "",
            points: "",
            description: "",
            url: "",
            content: "",
            options: {
                0: false,
                1: false,
                2: false
            }
        }
    }
    componentWillMount() {
        if (this.props.id !== undefined) {
            this.setState({ id: this.props.id })
            this.getKennisDetail(this.props.id)
        }
    }
    getKennisDetail(id) {
        Api.GetApi(FETCH_URL + "B/" + id, this.props.history).then(course => {
            if (course !== undefined) {
                this.setState({ options: { ...this.state.options, 0: course.diploma, 1: course.visible, 2: course.permanent } })
                this.setState({ level: course.level, })
                this.setState({ name: course.name, })
                this.setState({ institution: course.institution, })
                this.setState({ city: course.city, })
                this.setState({ points: course.points, })
                this.setState({ country: course.country, })
                this.setState({ url: course.url, })
                this.setState({ phoneNumber: course.phoneNumber, })
                this.setState({ content: course.content, })
                this.setState({ description: course.description, })
                this.setState({ refNumber: course.reference, })
                if (course.courseDate !== null) {
                    this.setState({ day: parseInt(course.courseDate.slice(8, 10)), })
                    this.setState({ month: parseInt(course.courseDate.slice(5, 7)), })
                    this.setState({ year: course.courseDate.slice(0, 4), })
                }
            }
        })
    }
    // Function that will be executed when the submit button (Toevoegen) is pressed
    handleSubmit(event) {
        event.preventDefault()
        this.setState({ "Diploma": this.state["options"][0] }, function () {
            this.setState({ "Visible": this.state["options"][1] }, function () {
                this.setState({ "Permanent": this.state["options"][2] }, function () {
                    Api.PostApi(FETCH_URL, this.state, this.props.history)
                        .then(response => {
                            if (response == undefined) {
                                this.setState({ errors: response });
                            } else {
                                alert(this.props.id !== undefined ? "Course updated" : "Course added")
                                window.location.href = "/admin/kennis/bijeenkomst";
                            }

                        })
                })
            })
        })


        // TODO: Post this.state to the API

    }

    // Function to manage the changes of the text fields and selects
    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        this.setState({ [name]: value })
    }

    // Function to manage the changes of the option checkboxes
    handleOptionsChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        const checked = target.checked
        this.setState({ [name]: { ...this.state[name], [value]: checked } })
    }

    render() {

        return (
            <div>
                <Form horizontal onSubmit={this.handleSubmit}>
                    <FormGroup controlId="BijeenkomstToevoegenRefNr">
                        <Col componentClass={ControlLabel} sm={4}>
                            Referentienr.
                        </Col>
                        <Col sm={6}>
                            <FormControl.Static name="refNumber" value={this.state.refNumber} onChange={this.handleChange}>
                                {this.state.refNumber == "" ? "wordt automatisch gegenereerd" : this.state.refNumber}
                            </FormControl.Static>
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BijeenkomstToevoegenNiveau">
                        <Col componentClass={ControlLabel} sm={4}>
                            Niveau
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="level" value={this.state.level} onChange={this.handleChange} />
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BijeenkomstToevoegenInstelling">
                        <Col componentClass={ControlLabel} sm={4}>
                            Naam instelling
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="institution" value={this.state.institution} required onChange={this.handleChange} />
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BijeenkomstToevoegenOpleiding">
                        <Col componentClass={ControlLabel} sm={4}>
                            Naam opleiding
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="name" value={this.state.name} required onChange={this.handleChange} />
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BijeenkomstToevoegenPlaats">
                        <Col componentClass={ControlLabel} sm={4}>
                            Plaats
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="city" value={this.state.city} onChange={this.handleChange} />
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BijeenkomstToevoegenDatum">
                        <Col componentClass={ControlLabel} sm={4}>
                            Datum
                        </Col>
                        <Col sm={6}>
                            <FormControl componentClass="select" placeholder="" name="day" value={this.state.day} onChange={this.handleChange}>
                                <option value="">dag</option>
                                {getDayOptions}
                            </FormControl>
                            <FormControl componentClass="select" placeholder="" name="month" value={this.state.month} onChange={this.handleChange}>
                                <option value="">maand</option>
                                {getMonthOptions}
                            </FormControl>
                            <FormControl componentClass="select" placeholder="" name="year" value={this.state.year} onChange={this.handleChange}>
                                <option value="">jaar</option>
                                {getYearOptions()}
                            </FormControl>
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BijeenkomstToevoegenTelefoonnummer">
                        <Col componentClass={ControlLabel} sm={4}>
                            Telefoonnummer
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="phoneNumber" value={this.state.phoneNumber} onChange={this.handleChange} />
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BijeenkomstToevoegenWaardering">
                        <Col componentClass={ControlLabel} sm={4}>
                            Waardering
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="points" value={this.state.points} required onChange={this.handleChange} />
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BijeenkomstToevoegenOpmerking">
                        <Col componentClass={ControlLabel} sm={4}>
                            Opmerking
                        </Col>
                        <Col sm={6}>
                            <FormControl componentClass="textarea" name="description" value={this.state.description} onChange={this.handleChange} rows="5" />
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BijeenkomstToevoegenURL">
                        <Col componentClass={ControlLabel} sm={4}>
                            URL
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="url" value={this.state.url} onChange={this.handleChange} />
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BijeenkomstToevoegenInhoud">
                        <Col componentClass={ControlLabel} sm={4}>
                            Inhoud
                        </Col>
                        <Col sm={6}>
                            <FormControl componentClass="textarea" name="content" value={this.state.content} onChange={this.handleChange} rows="5" />
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="BijeenkomstToevoegenOpties">
                        <Col componentClass={ControlLabel} sm={4}>
                            Opties
                        </Col>
                        <Col sm={6}>
                            {Api.getEducationOptions().map((option, index) =>
                                <Checkbox
                                    name="options"
                                    value={index}
                                    key={"option" + index}
                                    checked={this.state.options[index]}
                                    onChange={this.handleOptionsChange}>
                                    {option}
                                </Checkbox>
                            )}
                        </Col>
                    </FormGroup>

                    <FormGroup>
                        <Col sm={12}>
                            <LinkContainer to="/admin/kennis/bijeenkomst"><Button type="button" className="pull-left">Annuleren</Button></LinkContainer>
                            <Button type="submit" className="pull-right">Toevoegen</Button>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}

export default BijeenkomstAdd;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Kennis/Add/BijeenkomstAdd.js